import { FelaCSS, colors } from '@bridebook/ui';

interface IStyleProps {
  isActive: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
  reviewsWrap(hasOnTestimonialsClick: boolean): FelaCSS;
}

const styles = ({ isActive }: IStyleProps): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    fontDefaultSemiBold: 16,
    lineHeight: '1em',
    color: isActive ? colors.silver : colors.alto,
  },
  reviewsWrap: (hasOnTestimonialsClick) => ({
    flexDirection: 'row',
    alignItems: 'center',
    ...(hasOnTestimonialsClick && {
      cursor: 'pointer',
    }),
  }),
});

export default styles;
